import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ContactMePage } from '@games/ui';
import NonogramPage from 'features/puzzle/components/DefaultPage';
import TopTimePage from 'features/puzzle/components/TopTimePage';
import HowToSolvePage from 'features/home/components/HowToSolvePage';
import {
  LoginPage,
  LogoutPage,
  RegisterPage,
  PrefsPage,
  PasswordPage,
} from '@games/ui';
import PrivacyPolicyPage from 'features/home/components/PrivacyPolicyPage';
import TermsOfServicePage from 'features/home/components/TermsOfServicePage';
import ContactsPage from 'features/home/components/ContactsPage';
import AppsPage from 'features/home/components/AppsPage';
import { DailyTimePage } from 'features/puzzle/components/DailyTimePage';
import { DailyArchivePage } from 'features/puzzle/components/DailyArchivePage';

const pathsWithLang = (path: string) => ([
  `${path}`,
  `/:lang([a-z][a-z])${path}`,
]);

const Router: React.FC = () => (
  <Switch>
    <Route
      path={pathsWithLang('/apps')}
      component={AppsPage}
    />

    <Route
      path={pathsWithLang('/login')}
      component={LoginPage}
    />
    <Route
      path={pathsWithLang('/logout')}
      component={LogoutPage}
    />
    <Route
      path={pathsWithLang('/register')}
      component={RegisterPage}
    />
    <Route
      path={pathsWithLang('/prefs')}
      component={PrefsPage}
    />
    <Route
      path={pathsWithLang('/password')}
      component={PasswordPage}
    />

    <Route
      path={[
        "/nonogram/:lang([a-z][a-z])/blog/(.*)",
        ...pathsWithLang('/blog/(.*)'),
        ...pathsWithLang('/how-to-solve'),
      ]}
      component={HowToSolvePage}
    />


    <Route
      path={pathsWithLang('/contact')}
      component={ContactMePage}
    />
    <Route
      path={pathsWithLang('/contacts')}
      component={ContactsPage}
    />

    <Route
      path={pathsWithLang('/privacy')}
      component={PrivacyPolicyPage}
    />

    <Route
      path={pathsWithLang('/tos')}
      component={TermsOfServicePage}
    />

    <Route
      path={[
        '/nonogram/top',
        ...pathsWithLang('/top'),
      ]}
      component={TopTimePage}
    />


    <Route
      path="/nonogram/nonograms/puzzle/:lang([a-z][a-z])/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/puzzle/:lang([a-z][a-z])/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/nonograms/:lang([a-z][a-z])/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/:lang([a-z][a-z])/nonograms/puzzle/:puzzleId(\d+)"
      component={NonogramPage}
    />

    <Route
      path="/nonogram/:lang([a-z][a-z])/:size(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/:lang([a-z][a-z])"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/nonograms/puzzle/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/puzzle/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/nonograms/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/:size(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonogram/"
      component={NonogramPage}
    />
    <Route
      path="/nonograms/puzzle/:lang([a-z][a-z])/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/puzzle/:lang([a-z][a-z])/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonograms/:lang([a-z][a-z])/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/:lang([a-z][a-z])/nonogram/puzzle/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/:lang([a-z][a-z])/nonogram/:size(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/:lang([a-z][a-z])/:size(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonograms/puzzle/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/puzzle/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/nonograms/:puzzleId(\d+)"
      component={NonogramPage}
    />
    <Route
      path="/:lang([a-z][a-z])/daily/:date(\d{4}-\d{2}-\d{2})"
      component={NonogramPage}
    />
    <Route
      path="/daily/:date(\d{4}-\d{2}-\d{2})"
      component={NonogramPage}
    />
    <Route
      path="/:lang([a-z][a-z])/daily/top/:date(\d{4}-\d{2}-\d{2})"
      component={DailyTimePage}
    />
    <Route
      path="/daily/top/:date(\d{4}-\d{2}-\d{2})"
      component={DailyTimePage}
    />
    <Route
      path="/:lang([a-z][a-z])/daily/top"
      component={DailyTimePage}
    />
    <Route
      path="/daily/top"
      component={DailyTimePage}
    />
    <Route
      path="/:lang([a-z][a-z])/daily/archive/:year(\d{4})-:month(\d{2})"
      component={DailyArchivePage}
    />
    <Route
      path="/daily/archive/:year(\d{4})-:month(\d{2})"
      component={DailyArchivePage}
    />
    <Route
      path="/:lang([a-z][a-z])/daily/archive"
      component={DailyArchivePage}
    />
    <Route
      path="/daily/archive"
      component={DailyArchivePage}
    />
    <Route
      path="/:lang([a-z][a-z])/daily"
      component={NonogramPage}
    />
    <Route
      path="/daily"
      component={NonogramPage}
    />
    <Route
      component={NonogramPage}
    />
  </Switch>
);

export default Router;
